// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__oPzkv","col":"CardReaderDesc_col__9RqIa","label":"CardReaderDesc_label__1JXO2"};